import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LayerPanelState {
  /** Whether the layer panel is visible */
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  toggle: () => void;
}

/**
 * Persistent store for layer panel visibility preference
 * Uses localStorage to remember user's preference across sessions
 */
export const useLayerPanelState = create<LayerPanelState>()(
  persist(
    (set) => ({
      isVisible: true, // Default to visible
      setIsVisible: (isVisible) => set({ isVisible }),
      toggle: () => set((state) => ({ isVisible: !state.isVisible })),
    }),
    {
      name: "ramp-editor-layer-panel",
    }
  )
);
